import { useStaticQuery, graphql } from 'gatsby';
import { GlobalTextsModel, IGlobalTexts } from '../models/global-texts-model';

export const useGlobalTranslations = (): IGlobalTexts => {
  const { kontentItemGlobalTexts } = useStaticQuery(
    graphql`
      query {
        kontentItemGlobalTexts {
          elements {
            optional {
              value
            }
            email_is_incorrect {
              value
            }
            service_worker_update_text {
              value
            }
            request_error {
              value
            }
            next_story {
              value
            }
            pagination_next {
              value
            }
            pagination_previous {
              value
            }
            all {
              value
            }
            all_experts {
              value
            }
            share {
              value
            }
            popular {
              value
            }
            my_blog_posts {
              value
            }
            my_presentations {
              value
            }
            my_latest_blog_post {
              value
            }
            author_at_softwarehut {
              value
            }
            load_more {
              value
            }
            job_offert_application {
              value
            }
            job_offert_requirements {
              value
            }
            we_offer_title {
              value
            }
            where_and_when {
              value
            }
            no_events {
              value
            }
            upcoming_events {
              value
            }
            past_events {
              value
            }
            sending_mail {
              value
            }
            recaptcha_error_message {
              value
            }
            mail_send_success_message {
              value
            }
            job_type_title {
              value
            }
            job_offer_description {
              value
            }
            join_our_awesome_team {
              value
            }
            close {
              value
            }
          }
        }
      }
    `
  );
  return GlobalTextsModel.create(kontentItemGlobalTexts);
};
